import Action from './baseActions';

// Types

export enum WorkspaceConfigActionTypes {
  UPDATE_WORKSPACE_CONFIG = 'workspace_config/update',
  UPDATING_WORKSPACE_CONFIG = 'workspace_config/updating',
  UPDATED_WORKSPACE_CONFIG = 'workspace_config/updated',
  UPDATING_WORKSPACE_CONFIG_FAILED = 'workspace_config/updating_failed',

  LOAD_CURRENT_WORKSPACE_CONFIG = 'workspace_config/load_current',
  LOADING_CURRENT_WORKSPACE_CONFIG = 'workspace_config/loading_current',
  LOADED_CURRENT_WORKSPACE_CONFIG = 'workspace_config/loaded_current',
  LOADING_CURRENT_WORKSPACE_CONFIG_FAILED = 'workspace_config/loading_current_failed',
}

// Interfaces

export interface IUpdateWorkspaceConfigAction extends Action {
  type: WorkspaceConfigActionTypes.UPDATE_WORKSPACE_CONFIG;
  payload: {
    name: string,
    value: any,
    type?: string,
  }
}

export interface IUpdatingWorkspaceConfigAction extends Action {
  type: WorkspaceConfigActionTypes.UPDATING_WORKSPACE_CONFIG;
}

export interface IUpdatedWorkspaceConfigAction extends Action {
  type: WorkspaceConfigActionTypes.UPDATED_WORKSPACE_CONFIG;
  payload: any;
}

export interface IUpdatingWorkspaceConfigFailedAction extends Action {
  type: WorkspaceConfigActionTypes.UPDATING_WORKSPACE_CONFIG_FAILED;
}

export interface ILoadCurrentWorkspaceConfigAction extends Action {
  type: WorkspaceConfigActionTypes.LOAD_CURRENT_WORKSPACE_CONFIG;
}

export interface ILoadingCurrentWorkspaceConfigAction extends Action {
  type: WorkspaceConfigActionTypes.LOADING_CURRENT_WORKSPACE_CONFIG;
}

export interface ILoadedCurrentWorkspaceConfigAction extends Action {
  type: WorkspaceConfigActionTypes.LOADED_CURRENT_WORKSPACE_CONFIG;
  payload: any;
}

export interface ILoadingCurrentWorkspaceConfigFailedAction extends Action {
  type: WorkspaceConfigActionTypes.LOADING_CURRENT_WORKSPACE_CONFIG_FAILED;
}

// Functions

export function updateWorkspaceConfig(name: string, value: any, type?: string): IUpdateWorkspaceConfigAction {
  return {
    type: WorkspaceConfigActionTypes.UPDATE_WORKSPACE_CONFIG,
    payload: {
      name,
      value,
      type,
    }
  }
}

export function updatingWorkspaceConfig(): IUpdatingWorkspaceConfigAction {
  return {
    type: WorkspaceConfigActionTypes.UPDATING_WORKSPACE_CONFIG,
  }
}

export function updatedWorkspaceConfig(value: any): IUpdatedWorkspaceConfigAction {
  return {
    type: WorkspaceConfigActionTypes.UPDATED_WORKSPACE_CONFIG,
    payload: value
  }
}

export function updatingWorkspaceConfigFailed(): IUpdatingWorkspaceConfigFailedAction {
  return {
    type: WorkspaceConfigActionTypes.UPDATING_WORKSPACE_CONFIG_FAILED
  }
}

export function loadCurrentWorkspaceConfig(): ILoadCurrentWorkspaceConfigAction {
  return {
    type: WorkspaceConfigActionTypes.LOAD_CURRENT_WORKSPACE_CONFIG
  }
}

export function loadingCurrentWorkspaceConfig(): ILoadingCurrentWorkspaceConfigAction {
  return {
    type: WorkspaceConfigActionTypes.LOADING_CURRENT_WORKSPACE_CONFIG
  }
}

export function loadedCurrentWorkspaceConfig(value: any): ILoadedCurrentWorkspaceConfigAction {
  return {
    type: WorkspaceConfigActionTypes.LOADED_CURRENT_WORKSPACE_CONFIG,
    payload: value
  }
}

export function loadingCurrentWorkspaceConfigFailed(): ILoadingCurrentWorkspaceConfigFailedAction {
  return {
    type: WorkspaceConfigActionTypes.LOADING_CURRENT_WORKSPACE_CONFIG_FAILED
  }
}

export type WorkspaceConfigActions =
  IUpdateWorkspaceConfigAction |
  IUpdatingWorkspaceConfigAction |
  IUpdatedWorkspaceConfigAction |
  IUpdatingWorkspaceConfigFailedAction |
  ILoadCurrentWorkspaceConfigAction |
  ILoadingCurrentWorkspaceConfigAction |
  ILoadedCurrentWorkspaceConfigAction |
  ILoadingCurrentWorkspaceConfigFailedAction;
